export default __webpack_public_path__ + "static/media/Delete.1129c53a.svg";